<template>
  <div>
    <v-container fluid class="ma-0 pa-0">
      <router-link to="/richmenu" class="text-decoration-none">
        <v-btn icon class="ml-10 mt-5">
          <v-icon color="secondary" style="font-size: 45px"
            >mdi-chevron-left</v-icon
          >
        </v-btn>
      </router-link>
    </v-container>
    <v-container>
      <h3 class="mb-4 primary--text">Analytics</h3>

      <DateSelecter
        v-model="date"
        :show-time="true"
        @changeDate="changeDate"
      ></DateSelecter>

      <div ref="setWidth" class="setKonvaWidth"></div>
      <template v-if="richMenu">
        <h4 class="my-4">Name : {{ richMenu.name }}</h4>
        <div
          id="template4Set"
          class="mx-auto my-4"
          style="
            box-sizing: border-box;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
          "
        >
          <v-stage
            ref="stage"
            class="mt-5"
            :config="{
              width: richMenu.content_json.size.width * scaleState,
              height: richMenu.content_json.size.height * scaleState
            }"
            style="text-align: -webkit-center; cursor: pointer"
          >
            <v-layer>
              <v-image
                :config="{
                  image: image,
                  width: richMenu.content_json.size.width * scaleState,
                  height: richMenu.content_json.size.height * scaleState
                }"
              />
              <template v-for="(area, index) in richMenu.content_json.areas">
                <v-rect
                  :key="index"
                  :config="{
                    width: area.bounds.width * scaleState,
                    height: area.bounds.height * scaleState,
                    x: area.bounds.x * scaleState,
                    y: area.bounds.y * scaleState,
                    stroke: '#FFFFFF',
                    strokeWidth: parseInt(lineReg),
                    fill: getHeatmapColor(area) || 'white',
                    opacity: getHeatmapColor(area) ? 0.5 : 0
                  }"
                  @click="
                    currentIndex =
                      currentIndex != getAreaIndex(area)
                        ? getAreaIndex(area)
                        : null
                  "
                ></v-rect>
                <v-text
                  :key="'text_' + index"
                  :config="{
                    text:
                      getAreaIndex(area) != null
                        ? getAreaIndex(area) + 1
                        : null,
                    width: area.bounds.width * scaleState,
                    x: area.bounds.x * scaleState,
                    y: (area.bounds.y + area.bounds.height / 2) * scaleState,
                    fill: 'white',
                    fontSize: 20,
                    align: 'center'
                  }"
                />
              </template>
            </v-layer>
          </v-stage>
          <div class="pl-4 keyboard py-2">
            <v-icon style="font-size: 35px; float: left" color="#ffffff"
              >mdi-keyboard</v-icon
            >
            <div
              class="pa-1 text-center"
              style="padding-right: 40px !important; min-height: 32px"
            >
              <span
                >{{ richMenu.content_json.chatBarText }}
                <v-icon color="#ffffff"> mdi-menu-down </v-icon>
              </span>
            </div>
          </div>
        </div>
      </template>

      <div ref="chartdiv" class="mt-4"></div>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="typeData"
        :items-per-page="5"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr
            style="cursor: pointer"
            :class="{ primary: currentIndex == item.index }"
            @click="
              currentIndex = currentIndex != item.index ? item.index : null
            "
          >
            <td>
              {{ item.index + 1 }}
            </td>
            <td>{{ item.type }}</td>
            <td>{{ item.value }}</td>
            <td class="text-center">{{ item.count }}</td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">{{ $t('note_analytics') }}</div>
    </v-container>
  </div>
</template>

<script>
import DateSelecter from '@/components/DateSelecter.vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)
export default {
  components: {
    DateSelecter
  },
  data() {
    return {
      lineReg: '1',
      date: null,
      loading: true,
      typeData: [],
      currentIndex: null,

      headers: [
        {
          text: 'No.',
          value: 'index'
        },
        { text: 'Type', value: 'type' },
        { text: 'Value', value: 'value' },
        { text: 'Count', value: 'count', align: 'center' }
      ],
      image: null,
      richMenu: undefined,
      maxWidth: 0
    }
  },
  computed: {
    scaleState() {
      if (this.richMenu)
        return this.maxWidth / this.richMenu.content_json.size.width
      else return 1
    }
  },
  async mounted() {
    // console.log(this.getColorForPercentage(0.7));
    this.maxWidth = this.$refs.setWidth.clientWidth
    // await this.loadData();
    var richmenu_response = await this.$store.dispatch(
      'lineRichmenuManager/getLineRichMenu'
    )
    if (richmenu_response) {
      this.richMenu = richmenu_response.data.data.find((richMenu) => {
        return richMenu.id == this.$route.params.richmenuid
      })
      if (this.richMenu) {
        try {
          this.$set(
            this.richMenu,
            'content_json',
            JSON.parse(this.richMenu.content_json)
          )
        } catch (error) {
          console.error(error)
        }
        this.image = await this.loadImage(this.richMenu.image_url)
      }
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    getAreaIndex(area) {
      if (area && area.action) {
        let { result } = this.findDataFromArea(area)
        if (result) {
          return result.index
        }
      }
      return null
    },
    findDataFromArea(area) {
      var val
      switch (area.action.type) {
        case 'uri':
          if (area.action.uri.indexOf('rurl') != -1) {
            var urlParams = new URLSearchParams(area.action.uri)
            if (urlParams.has('rurl')) {
              val = urlParams.get('rurl')
            }
          } else {
            val = area.action.uri
          }
          break
        case 'text':
        case 'postback':
        case 'richmenuswitch':
          val = area.action.data
      }

      var total =
        this.typeData && this.typeData.length > 0
          ? this.typeData
              .map((el) => {
                return parseInt(el.count)
              })
              .reduce((prev, curr) => {
                return prev + curr
              }, 0)
          : 0

      var result = this.typeData
        ? this.typeData.find((el) => {
            return val && val.includes(el.value)
          })
        : null
      return {
        result,
        total
      }
    },
    getHeatmapColor(area) {
      if (area && area.action) {
        let { total, result } = this.findDataFromArea(area)

        if (result) {
          return this.getColorForPercentage(parseInt(result.count) / total)
        } else {
          return null
        }
      }
      return null
    },
    getColorForPercentage(pct) {
      var percentColors = [
        { pct: 0.0, color: { r: 0xff, g: 0x00, b: 0 } },
        { pct: 0.5, color: { r: 0xff, g: 0xff, b: 0 } },
        { pct: 1.0, color: { r: 0x00, g: 0xff, b: 0 } }
      ]

      for (var i = 1; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
          break
        }
      }
      var lower = percentColors[i - 1]
      var upper = percentColors[i]
      var range = upper.pct - lower.pct
      var rangePct = (pct - lower.pct) / range
      var pctLower = 1 - rangePct
      var pctUpper = rangePct
      var color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
      }
      return this.rgbToHex(color)
      // or output as hex if preferred
    },
    componentToHex(c) {
      var hex = c.toString(16)
      return hex.length == 1 ? '0' + hex : hex
    },
    rgbToHex({ r, g, b }) {
      return (
        '#' +
        this.componentToHex(r) +
        this.componentToHex(g) +
        this.componentToHex(b)
      )
    },
    editBound() {},
    handleMouseEnter() {},
    handleMouseLeave() {},

    async loadData() {
      this.loading = true
      var response = await this.$store.dispatch(
        'lineRichmenuManager/getLineRichMenuStat',
        {
          richmenu_id: this.$route.params.richmenuid,
          datefrom: this.date.start,
          dateto: this.date.end
        }
      )

      this.typeData = response.data.result.map((el, index) => {
        return { ...el, index }
      })
      this.chart = this.createColumnSeries(this.typeData, this.$refs.chartdiv, {
        category: 'value',
        value: 'count'
      })
      this.loading = false
    },
    async getLineRichmenuPackageByAccount() {
      var res = await this.$store.dispatch(
        'lineRichmenuManager/lineRichmenuPackageByAccount'
      )
      if (res) {
        this.packageGroup = res.data.data
        if (this.GroupId === null) {
          this.$store.dispatch(
            'lineRichmenuManager/setSelectGroupId',
            res.data.data[0]
          )
        }
        this.groupId = this.GroupId.id
        this.groupSelect = this.GroupId
        // 2.3 baht per day
        this.total = parseFloat(
          (
            this.addNewDuringMonth(this.groupSelect.expired_timestamp) * 2.3 +
            2.3
          ).toFixed(2)
        )
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong.`
        })
      }
    },
    async changeDate() {
      await this.loadData()
    },
    createColumnSeries(data, refs, { value, category }) {
      let chart = am4core.create(refs, am4charts.XYChart)
      chart.colors.list = [
        am4core.color('#FF706B'),
        am4core.color('#FF2948'),
        am4core.color('#8c9eff')
      ]
      chart.data = data
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = category
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis.title.text = value
      var series = chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = value
      series.dataFields.categoryX = category

      return chart
    }
  }
}
</script>

<style lang="scss" scoped></style>
